import React from 'react'
import { FormError } from 'components/atoms'
import {
  CheckboxUnmarked,
  CheckboxMarked,
  RadioUnmarked,
  RadioMarked,
} from 'components/atoms/Icons'

interface Props {
  id: string
  label?: string | React.ReactNode
  name?: string
  value?: any
  size?: 'md'
  className?: string
  checked?: boolean
  radioStyle?: boolean
  readOnly?: boolean
  disabled?: boolean
  status?: '' | 'success' | 'error'
  errorMessage?: string
  onBlur?: (e: any) => void
  onFocus?: (e: any) => void
  onChange?: (e: any) => void
}

const FormCheckboxPrivacy = (props: Props) => {
  const {
    id = '',
    label = '',
    name = '',
    value = '',
    size = 'md',
    className = '',
    checked = false,
    radioStyle = false,
    readOnly = false,
    disabled = false,
    status = '',
    errorMessage = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
  } = props

  const classNames = `
    form-checkbox 
    form-checkbox--${size}
    ${readOnly ? ' form-checkbox--readonly' : ''}
    ${disabled ? ' form-checkbox--disabled' : ''}
    ${status ? ` form-checkbox--${status}` : ''}
    ${className ? ` ${className}` : ''}`

  return (
    <div className={classNames}>
      <label htmlFor={id} className="form-checkbox__input-wrap">
        <input
          checked={checked}
          name={name}
          value={value}
          className="form-checkbox__input"
          type="checkbox"
          readOnly={readOnly}
          disabled={disabled}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
          id={id}
        />
        <span className="form-checkbox__styledinput">
          {radioStyle ? (
            checked ? (
              <RadioMarked />
            ) : (
              <RadioUnmarked />
            )
          ) : checked ? (
            <CheckboxMarked />
          ) : (
            <CheckboxUnmarked />
          )}
        </span>
        <span className="form-checkbox__label">{label}</span>
      </label>
      <FormError message={errorMessage} visible={status === 'error'} />
    </div>
  )
}

export default FormCheckboxPrivacy
